export const ru = {
    common: {
        success: "Успех!",
        next: 'Далее',
        discount: 'Скидка',
        pay: 'Оплатить',
        buy: 'Купить',
        replenishment: 'Пополнение',
        writeOff: 'Списание',
        in_installments: 'Оформить в рассрочку',
        payment_pending_for_installment: 'Пожалуйста, завершите платеж как можно скорее, чтобы подтвердить свое участие',
        price: 'Цена',
        schedule: 'Записаться',
        orderPaid: 'Этот заказ уже успешно оплачен',
        certificate: 'Сертификат',
        promocode: 'Промокод',
        bookingClosed: 'Запись закрыта',
        chooseOtherSlot: 'Выбрать другой слот',
        placesEnded: 'К сожалению, места закончились, но вы можете выбрать любое из доступных направлений',
        placesWithDiscountEnded1: 'Вы хотите купить больше мест ({{places}}) со скидкой, чем осталось ({{remainder}}). Чтобы всё получилось, уменьшите количество мест. Но если иначе никак, напишите в TG',
        placesWithDiscountEnded2: '— что-нибудь придумаем',
        toMain: 'На главную',
        pluralizePlaces: 'мест',
        freeSits: 'свободных мест',
        member: 'Участник',
        canEditData: 'Отредактировать данные можно в ',
        personalAccount: 'личном кабинете',
        noProductsAvailable: 'Кажется нет доступных продуктов...',
        goToCalendar: 'Перейти в календарь',
        orderDeletedDescription: 'Время пролетело быстро — места на это приключение совсем недавно закончились. Но у нас точно есть что-то в эти же даты или в похожей акватории.',
        orderDeletedDescription2: 'Команда участников этого приключения уже сформирована — мы продали все места. Мы будем рады увидеть вас на других маршрутах — у нас точно есть что-то в эти даты или в похожей акватории.',
        installment: {
            show: 'Оформить в рассрочку от Т-Банка',
            select: 'Выбрать рассрочку',
            altMessage: 'В рассрочку от Т-Банка',
            helpers: {
                month: 'месяц',
                months: 'месяца',
                months2: 'месяцев',
            },
            info: 'Вы можете оплатить сразу или выбрать рассрочку от Т-Банка: {{installments}}.',
            warning: 'Рассрочка не может быть взята на продукты стоимостью менее 3000р после всех скидок.'
        },
        layout: {
            pickDate: 'Выбор дат',
            members: 'Участники',
            confirmation: 'Подтверждение',
            payment: 'Оплата',
            finish: 'Завершение',
            payExtraCardDesc: 'После нажатия система переведет вас на сайт оплаты',
        },
        insuranceModal: {
            headerLabel: "Страховка",
            title: "Это займет 30 секунд",
            howItWorks: "Как все работает",
            steps: {
              1: "Даете согласие на бесплатную расширенную спортивную страховку на время вашего бронирования",
              2: "Получаете на почту полис — вы будете застрахованы на 500 000₽",
              3: "Если вам придется обратиться в страховую, сообщите сотрудникам базы — они помогут. Подробности <1>по ссылке</1>",
            },
            dataReview: "Проверьте данные",
            dataReviewNotice: "Имя, фамилия и дата рождения должны быть как в паспорте",
            button: "Оформить бесплатно",
            formRequirements: "Чтобы оформить страховку необходимо корректно заполнить все поля",
            selfCoverageOnly: "* Оформить страховку можно только для себя. Если вы решили выйти на воду с друзьями, чтобы подключить страхование, им нужно зарегистрироваться отдельно со своего аккаунта на ту же тренировку, прогулку или гонку.",
        },
        fields: {
            "phone": {
                "label": "Номер телефона",
                "validation": {
                    "required": "Поле обязательно для заполнения",
                    "format": "Введите корректный номер телефона"
                }
            },
            "phoneCode": {
                "label": "Введите код",
                "validation": {
                    "required": "Поле обязательно для заполнения",
                    "invalidCode": "Некорректный код",
                    "unknownError": "Что-то пошло не так",
                    "phoneTaken": "Этот номер уже занят"
                }
            },
            "password": {
                "label": "Пароль",
                "signUpLabel": "Придумайте пароль",
                "placeholder": "С цифрами, а лучше и с символами",
                "strength": {
                    "easy": "Не вполне безопасный пароль",
                    "medium": "Пароль средней сложности",
                    "hard": "Выглядит безопасно"
                },
                "validation": {
                    "passError": "Ой! У нас нет такого сочетания почты и пароля",
                    "required": "Поле обязательно для заполнения",
                    "minLength": "Минимальная длина пароля - 5 символов",
                    "pattern": "Недопустимые знаки (возможны цифры, латинские буквы и спецсимволы ! @ # %)"
                }
            },
            "captcha": {
                "validation": {
                    "wrongCaptcha": "Ой! Вы не прошли капчу!"
                }
            },
            "email": {
                "label": "Email",
                "placeholder": "Для подтверждений и чеков",
                "validation": {
                    "emailTaken": "Такой email у нас уже есть",
                    "regEmailTaken": "Такой аккаунт у нас уже есть",
                    "required": "Поле обязательно для заполнения",
                    "pattern": "Кажется, в адресе почты ошибка"
                }
            },
            "consent": {
                "label": "Согласен на",
                "linkCaption": "обработку персональных данных",
                "linkAdvertising": "получение рекламных материалов",
                "validation": {
                    "consent": "Пожалуйста, подтвердите согласие на обработку персональных данных",
                    "advertising": "Пожалуйста, подтвердите согласие на получение рекламных материалов"
                }
            },
            "subscription": {
                "label": "Я согласен получать маркетинговые коммуникации"
            },
            "insurance": {
                "label": "Согласен с <1>правилами страхования</1> оформлением страховки и передачей <2>персональных данных</2> в ПАО СК Росгосстрах",
                "validation": "Пожалуйста, подтвердите согласие со всеми условиями страхования"
            },
            "firstName": {
                "label": "Имя",
                "placeholder": "Как вас зовут?",
                "validation": {
                    "required": "Поле обязательно для заполнения",
                    "pattern": "Кажется, в имени ошибка"
                }
            },
            "lastName": {
                "label": "Фамилия",
                "validation": {
                    "required": "Поле обязательно для заполнения"
                }
            }
        },
        buttons: {
            "switch": "English",
            "getCode": "Получить код",
            "signUp": "Зарегистрироваться",
            "loginViaEmail": "Войти по почте",
            "loginViaPhone": "Войти по номеру",
            "send": "Отправить",
            "getNewCode": "Получить новый код",
            "logIn": "Войти",
            "recoverPassword": "Восстановить пароль",
            "saveEmail": "Cохранить почту"
        },
        logIn: {
            "phone": {
                "title": "Войти и зарегистрироваться",
                "codeSent": "Код отправлен на номер",
                "requestCodeText": "Запросить код повторно через"
            },
            "password": {
                "title": "Войдите, чтобы продолжить"
            },
            error: {
                yandexAuth: 'Ошибка Яндекс авторизации'
            },
            vkAuthError: 'Ошибка авторизации через ВКонтакте',
            vkWidgetError: 'Ошибка загрузки ВК виджета',
        },
        fillingEmail: "В вашем аккаунте не указана почта\nПожалуйста, оставьте ее здесь",
        logInVia: "Войти с помощью",
        helpers: {
            "or": "или",
            "change": "изменить"
        },
        forgotPassword: {
            "linkCaption": "Забыли пароль?",
            "title": "Введите почту, которая была привязана к аккаунту. Мы отправим вам ссылку для восстановления пароля",
            "backToLogIn": "Вернуться к авторизации",
            "accountNotExists": "Данного аккаунта не существует",
            "signUpSuggestion": "Зарегистрироваться?",
            "restoreSuccess": "Письмо отправлено на почту {{email}}",
            "timerSent": 'Письмо уже отправлено. Повторная отправка доступна через {{timerCount}} секунд',
            "captcha": {
                "error": "Неверно введена капча. Попробуйте ещё раз.",
                "failed": "Проверка капчи не удалась. Пожалуйста, обновите страницу и попробуйте снова."
            }
        },
        signUp: {
            "title": "Создайте аккаунт",
            "gotAnAccount": "Уже есть аккаунт?",
            "logIn": "Войти",
            "signUpVia": "Зарегистрироваться с помощью"
        },
        social: {
            "fallbackText": "Мы выслали на почту корректные логин-пароль для входа в систему бронирования, если вы их не получили, свяжитесь с нашей службой поддержки",
            "successfulAuth": "Введите, пожалуйста, свое имя и фамилию, чтобы мы знали, как к вам обращаться"
        },
        redirect: "Редирект",
        file: 'Файл',
        telegram: 'Telegram'
    },
    inputs: {
        required: 'Поле обязательно для заполнения',
        pattern: 'Поле должно содержать заглавные буквы',
        cyrillicAndCapitalError: 'Поле должно содержать заглавные буквы на кириллице',
        maxLengthError: 'Максимальное количество символов - 25',
        maxLengthEnPassError: 'Максимальное кол-во символов – 25',
        onlyCyrillicError: 'Используйте только кириллицу',
        onlyLatinError: 'Используйте только латиницу',
        formatError: 'Заполните поле в формате',
        errorDateFormat: 'ДД.ММ.ГГГГ',
        firstName: {
            label: 'Имя',
            placeholder: 'ИВАН'
        },
        lastName: {
            label: 'Фамилия',
            placeholder: 'ИВАНОВ'
        },
        middleName: {
            label: 'Отчество',
            placeholder: 'ИВАНОВИЧ'
        },
        phone: {
            label: 'Номер телефона',
            pattern: 'Заполните поле в формате +7 (XXX) XXX-XX-XX',
            wrong: 'Некорректный номер телефона'
        },
        sailingExperience: {
            label: 'Яхтенный опыт',
            required: 'Укажите ваш опыт',
            defaultValue: 'Ваш опыт:',
            '0/7': 'нет опыта',
            '1/7': 'знаю базовое устройство яхты',
            '2/7': 'умею настраивать паруса',
            '3/7': 'хожу всеми курсами и могу пришвартоваться',
            '4/7': 'совершенствую технику в деталях',
            '5/7': 'предвижу ветер и ситуации на воде',
            '6/7': 'готовлюсь к победе в гонках',
            '7/7': 'парусный мастер, изучаю стратегию и тактику',
            'travel0/7': 'никогда не был(а) на яхте',
            'travel1/7': 'дергал(а) шкоты, держал(а) руль',
            'travel2/7': 'участвовал(а) в гонках',
            'travel3/7': 'был(а) в регате',
            'travel4/7': 'шкипер с правами',
        },
        email: {
            label: 'Электронная почта',
            pattern: 'Введите существующий адрес email'
        },
        emailShort: {
            label: 'Почта',
            placeholder: 'allo@silavetra.com'
        },
        birthdate: {
            label: 'Дата рождения'
        },
        enterPromocode: {
            placeholderPromo: 'Введите промокод',
            placeholderCert: 'Введите сертификат',
            label: 'Промокод/Сертификат',
            placeholder: 'Введите промокод или сертификат',
            submitButton: 'Применить',
            cancelButton: 'Отмена',
            wrongPromoOrCert: 'Промокод или сертификат недействителен',
            wrongPromo: 'Что-то сломалось, напишите в отдел заботы — поможем разобраться',
            wrongCert: 'Сертификат не существует. Напишите в отдел заботы — поможем разобраться.',
            corpCertApplied: 'Применен корпоративный сертификат.',
            corpCertAppliedDesc: 'Для корпоративных клиентов не предусмотрены другие скидки.',
            patternPromoPlaceholder: 'silavetra',
            patternCertPlaceholder: 'xxxx-xxxx-xxxx',
        },
        comment: {
            label: 'Комментарий',
            placeholder: 'Допишите в комментарий дополнительную информацию о вас или особое пожелание к поездке',
            travelPlaceholder: 'Укажите любые пожелания (например, ﻿к какому капитану вы хотите попасть или в какой экипаж).',
            maxLength: 'Комментарий слишком длинный, максимальная длина комментария 300 символов',
        },
        consents: {
            publicOffer: 'Согласен с публичной офертой',
            publicOfferNote: 'Занятия на яхтах — безопасные, но достаточно активные. Поэтому в целях вашей же безопасности мы не допускаем до тренировок и прогулок беременных и людей с серьезными травмами. Также мы не допускаем до тренировок участников в состоянии даже легкого алкогольного опьянения.',
            publicOfferError: 'Пожалуйста, подтвердите согласие с публичной офертой',
            validData: 'Даю согласие на обработку персональных данных в объеме, необходимом для оказания услуг, в том числе на передачу персональных данных третьим лицам',
            validDataError: 'Пожалуйста, подтвердите согласие на обработку персональных данных',
            returnPolicy: 'Согласен с условиями отмены и переноса',
            returnPolicyNote: 'Вы можете отменить занятие, если до него осталось больше 72 часов, а перенести — за 48 часов и более.',
            returnPolicyAltNote: 'Если до мероприятия остаётся менее 3 дней, к сожалению, возврат денежных средств невозможен',
            returnPolicyTrain: 'Тренировок',
            returnPolicyError: 'Пожалуйста, подтвердите согласие с условиями отмены и переноса тренировок',
            checkAge: 'Подтверждаю, что всем участникам больше {{checkAgeValue}} лет',
            checkAge2: '',
            pleaseCheckAgeValue: 'Пожалуйста, подтвердите, что всем участникам больше {{checkAgeValue}} лет. Если {{checkAgeValue}} лет нет, то приглашаем посетить ',
            pleaseCheckAgeValueEN: 'Пожалуйста, подтвердите, что всем участникам больше {{checkAgeValue}} лет.',
            ifHaveNoAge: 'Участники от 14 до 18 лет могут участвовать в наших занятиях только вместе с родителем или законным представителем. В этом случае, пожалуйста, не забудьте взять с собой паспорта. Если участникам меньше {{checkAgeValue}}  лет, приглашаем посетить ',
            childrenClub: 'детский клуб',
            checkAgeSecondPart: ', где есть тренировки и занятия для детей от 6 лет.',
        },
        city: {
            label: 'Город',
            placeholder: 'Введите город',
        },
        region: {
            label: 'Область',
            placeholder: 'Введите область',
        },
        telegram: {
            pattern: 'Вводите аккаунт телеграм через @',
            pattern_two: 'Допустимые символы a-z, 0-9, _'
        },
        passportDate: {
            error: "Паспорт недействителен в период путешествия, укажите в поле номер паспорта 0000",
        },
        gender: {
            label: 'Пол',
            error: 'Укажите пол',
            female: 'Ж',
            male: 'М',
            none: '-',
        },
        passportDateForeign: {
            error: 'Паспорт недействителен в период путешествия, укажите в поле номер паспорта 0000'
        },
        shirtSize: {
            required: 'Выберите размер футболки',
        },
        flat: {
            label: 'Квартира',
            error: 'Для многоквартирного дома заполните номер квартиры',
            ownHouse: 'Живу в частном доме'
        },
        street: 'Улица',
        house: 'Дом',
        address: {
            label: 'Адрес проживания покупателя*',
            validate: 'Укажите страну и город',
            fullAddressValidate: 'Укажите полный адрес (страна, город, улица, дом)',
            placeholder: 'Адрес по месту жительства',
        },
        provideAddress: 'Укажите точный адрес',
        passportFile: 'Паспорт'
    },
    discounts: {
        coachless: 'скидка за запись без инструктора',
        ownBoat: 'скидка за запись cо своим лучом',
        fullBook: 'скидка за полную лодку',
        subscription: 'Скидка из абонемента',
        people: 'От {{peopleCount}} человек скидка',
        peopleFullBoat: 'Скидка за лодку целиком',
        peopleFull: 'Скидка за бронирование от {{peopleCount}} человек',
        fullBookInstructor: 'скидка за лодку и без инструктора',
        discountLess: 'Вы выбрали абонемент с меньшим номиналом. Скидки уменьшатся',
        discountEqual: 'Сумма абонемента равна предыдущему. Скидки не меняются',
        discountRise: 'Вы выбрали абонемент с большим номиналом. Скидки увеличатся',
        discountCurrentOn: 'Зачислим на счет',
        discountSubscriptions: 'Скидки по абонементу',
        discountWillUpOn: 'Депозит для оплаты тренировок и гонок',
        discountOnYachtLuch: 'на килевые яхты (SV20 и другие)',
        discountOnGroupYachtLuch: 'групповые занятия на «Лучах»',
        discountOnIndividualLuch: 'индивидуальные занятия на «Лучах»',
        discountOnRace: 'гонки кроме Кубков Силы ветра',
        discountOnCup: 'кубки Силы ветра',
    },
    sport: {
        pluralizeBoats: 'лод',
        schedule: {
            selectors: {
                pickBase: 'Выберите базу',
                base: 'База',
                pickBoat: 'Выберите лодку',
                boat: 'Лодка',
                pickDate: 'Выберите дату',
                date: 'Дата',
                pickTime: 'Выберите время',
                time: 'Время',
                anyInstructor: 'Любой классный',
                instructorWarning: 'Мы стараемся учитывать ваши пожелания, но не всегда можем гарантировать присутствие конкретного инструктора.',
                availableSits: 'доступно мест',
                pickInstructor: 'Выберите инструктора',
                bookWholeBoat: 'Забронировать всю лодку',
                noEnoughSeatsToFull: 'Нет полностью свободных лодок',
                noVacantSeats: 'Места на выбранном мероприятии закончились, вы будете перенаправлены',
                bookWithoutInstructor: 'Записаться без инструктора',
                ownBoat: 'Записаться со свои лучом',
                withoutInstructor: 'Без инструктора',
                firstBookingLimitWarning: 'Приятно видеть, что у вас собралась большая классная компания — может, настало время организовать тренировку или гонку только для «своих»? Напишите нам на ',
                secondBookingLimitWarning: 'Кажется, вы планируете большое событие! Для компаний от 20 человек мы готовы организовать персональные тренировки или регаты. Напишите нам на ',
                BookingLimitEmail: 'event@silavetra.team',
                BookingLimitNumber: '+74951081503',
                makeItHappen: ', все устроим!',
                orCall: 'или позвоните ',
                tel: 'Телефон: ',
                email: 'Почта: '
            }
        },
        membersScreen: {
            fillOthers: 'Подтверждаю, что данные указаны верно',
            dontFillOthers: 'Не заполнять данные для остальных участников',
            startDate: 'Дата и время начала тренировки',
            subscriptionPayment: 'абонементом',
            subscriptionBalance: 'Баланс абонемента:',
            haveNoSubscription: 'У вас нет активного абонемента.',
            pay: 'Оплатить',
            participantDataRequired: 'Важно! Для пропуска на территорию яхт-клуба нам понадобятся ваши данные — настоящие имя и фамилия. Проверьте, что они заполнены верно'
        },
        membersCheckboxes: {
            insured: 'Добавить бесплатное страхование от Росгосстраха на время заезда'
        },
        noPlaces: 'Нет Мест',
    },
    travel: {
        regataRegister: 'Вы всего в паре шагов от приключения!',
        pickMembersCount: 'Выберите количество участников',
        noPlaces: 'Мест нет',
        title: 'Путешествие',
        startPlace: 'Место старта',
        startDate: 'Дата старта',
        weekdays: 'Дни недели',
        '20%': 'Хочу оплатить 20%, ',
        '50%': 'Вы можете оплатить 50%, ',
        '100%': 'Хочу оплатить 100%',
        partialPayText: 'а остальную часть - не позднее, чем за месяц до поездки. Обратите внимание, что при такой оплате частями стоимость путешествия увеличится.',
        arrivalDate: 'Дата поездки',
        include: 'Что входит в цену:',
        notInclude: 'Что не входит в цену:',
        freeSits: 'Свободных мест',
        selectPaymentType: 'Рассрочка от ТБанка или Частичная оплата',
        partialPayment: 'Частичная оплата',
        installmentPayment: 'Рассрочка от ТБанка',
        firstName: {
            label: 'Имя',
            placeholder: 'ИВАН'
        },
        lastName: {
            label: 'Фамилия',
            placeholder: 'ИВАНОВ'
        },
        membersCheckboxes: {
            insured: 'Добавить бесплатное страхование от Росгосстраха на время заезда'
        },
    },
    paymentTimer: {
        expired: 'Время на оплату заказа истекло, требуется создать новый заказ',
        haveTime: 'У вас осталось {{time}}, для того чтобы произвести оплату'
    },
    practice: {
        label: 'Практика',
        register: 'Вы всего в паре шагов от приключения!',
        '50%_extra': ', а остальную часть — не позднее, чем за месяц до поездки. Обратите внимание, что при оплате частями стоимость практики увеличится на 7%.',
    },
    errors: {
        placeLack: 'Недостаточно свободных мест',
        someoneAlready: 'Упс... Кто-то вас опередил и уже забронировал. Сейчас уже нет нужного количества мест. Попробуйте выбрать другое время.',
        expired: 'Упс... Время больше не доступно для бронирования. Попробуйте выбрать другое.',
        coachNotAvailable: 'У этого инструктора больше нет свободных мест.',
        phoneAlreadyUses: 'Телефон уже занят',
        requiredField: 'Это поле обязательно'
    },
    productContainer: {
        headerLabel: 'Бронирование'
    },
    headerMenu: {
        leave: 'Выйти',
        profile: 'Профиль'
    },
    addVkModal: {
        title: 'Упс...',
        inProfile: 'В профиле VK не указана почта. Мы не можем авторизовать без почты. Её можно указать в профиле',
        thisLink: 'по ссылке.',
        link: 'https://id.vk.com/account/#/security',
        otherVariants: 'Еще можно авторизоваться другим способом.'
    },
    school: {
        pickGroup: 'Выберите группу',
        group: 'Группа',
        place: 'Место',
        address: 'Адрес',
        freePlaces: 'Свободных мест',
        lecture: 'Лекция',
        '0/7': 'нет опыта',
        '1/7': 'ходил в качестве пассажира',
        '2/7': 'ходил в качестве члена экипажа, умею работать со шкотами, вязать узлы',
        '3/7': 'сам ходил в качестве рулевого несколько раз',
        '4/7': 'ходил много в качестве рулевого, есть опыт, нужны права',
        overbookError: 'К сожалению, все места закончились, но Вы можете выбрать другие доступные события ниже:',
        expiredError: 'К сожалению, дата старта лекции уже прошла, но Вы можете выбрать другие доступные события ниже:',
        noGroupsError: 'К сожалению, нет доступных занятий, но Вы можете выбрать другие доступные события ниже:',
        showAllLectures: 'Посмотреть все лекции',
        showAllTheories: 'Посмотреть все теории',
    },
    bookingCard: {
        direction: 'Направление',
        temperature: 'Температура',
        air: 'Воздух',
        water: 'Вода',
        waterTime: 'Время на воде в день',
        startTime: 'Время старта',
        discount: 'Скидка',
        members: 'Участники',
        price: 'Цена',
        free: 'БЕСПЛАТНО',
        from: 'от',
        to: 'до',
        outstandingPay: 'Осталось оплатить',
        difficultyLevel: 'Сложность',
        event: 'Событие',
        duration: 'Длительность',
        max: 'максимум',
        instructor: 'Инструктор',
        teacher: 'Преподаватель',
        name: 'Название',
        startTimeAt: 'НАЧАЛО ЗАНЯТИЯ В',
        place: 'Место проведения',
        h: 'Ч',
        m: 'М',
        title: 'Название',
        lecturer: 'Учитель',
    },
    helpers: {
        anHour: 'час',
        hours: 'часов',
        hours2: 'часа',
    },
    final: {
        processing: 'Ваша оплата еще находится в обработке. Ее статус обновится чуть позже.',
        processingWithInstallment: 'Мы отправили заявку на рассмотрение в банк. Как только он примет решение о рассрочке, вы получите письмо на почту, которую указывали при бронировании.',
        eventSuccess: 'Вы успешно прошли регистрацию на событие! Не забудьте подготовить все нужные вещи к {{date}}!',
        confirmationEmail: 'Письмо-подтверждение придет на почту, которую вы ранее указали. ',
        eventSuccessEmail: 'Не забудьте проверить папки «Промоакции» и «Спам». Если вам не пришло письмо подтверждения, вы всегда можете увидеть свое бронирование в <0>личном кабинете</0>. Остались вопросы? Напишите нам в <1>Телеграм</1>, на почту <2>{{email}}</2> или позвоните по телефону <3>{{phone}}</3>',
        contactPhone: '+7\u00A0495\u00A0108-15-03',
        contactEmail: 'allo@silavetra.com',
        contactTelegram: 'https://t.me/silavetrasila_bot',
        contactTelegramShort: '@silavetrasila_bot',
        tableEventSuccess: 'Вы успешно прошли регистрацию на событие! Не забудьте подготовить все нужные вещи к {{date}}!',
        materials: 'А пока можете ознакомиться с полезными материалами:',
        firstTrains: 'Первые парусные тренировки',
        takeOnTrain: 'Что брать с собой на тренировки',
        luchClothes: 'Как правильно одеться на «Лучи» и «Лазеры»',
        gloves: 'Перчатки для яхтинга: Испытание в бою',
        shoe: 'Эксперимент: какая обувь меньше скользит',
        onTheMain: 'На главную страницу',
        inCalendar: 'Добавить в календарь',
        inWhatCalendar: 'В какой календарь добавить событие?',
        bookMore: 'Забронировать еще',
        regattaSuccess: 'Вы успешно прошли регистрацию на регату. Приготовьте все необходимые вещи к {{date}}.',
        regattaSuccessRU:
            'Поздравляем, ваше бронирование подтверждено, и совсем скоро вы отправитесь в настоящее приключение. Мы сами в предвкушении!\n' +
            '\n' +
            'Письмо-подтверждение придет на почту, которую вы ранее указали. Не забудьте проверить папки «Промоакции» и «Спам».\n' +
            'Если вам не пришло письмо подтверждения, вы всегда можете увидеть свое бронирование в <0>личном кабинете</0>.\n' +
            '\n' +
            'Остались вопросы? Напишите нам в <1>Телеграм</1>, на почту <2>{{email}}</2> или позвоните по телефону <3>{{phone}}</3>\n',
        regattaSuccessWithInstallmentRU:
            'Поздравляем, бронирование подтверждено, а рассрочка уже одобрена банком. Совсем скоро вы отправитесь в настоящее приключение. Мы сами в предвкушении!\n' +
            '\n' +
            'Письмо-подтверждение придет на почту, которую вы ранее указали. Не забудьте проверить папки «Промоакции» и «Спам».\n' +
            'Если вам не пришло письмо подтверждения, вы всегда можете увидеть свое бронирование в <0>личном кабинете</0>.\n' +
            '\n' +
            'Остались вопросы? Напишите нам в <1>Телеграм</1>, на почту <2>{{email}}</2> или позвоните по телефону <3>{{phone}}</3>\n',
        regattaSuccessBye: 'До встречи под парусом!',
        questions: 'Если у вас остались вопросы, связанные с&nbsp;покупкой путешествия, позвоните по телефону ',
        orContactEmail: ' или напишите нам на почту ',
        infoOnEmail: 'В письме мы пришлем подробную информацию о путешествии и как к нему подготовиться.',
        waitEmail: 'Ожидайте письмо на почту по адресу, который указали при регистрации.',
        paymentSuccess: ' успешно принята.',
        paymentProcessing: ' находится в обработке. Ее статус обновится чуть позже.',
        yourPayment: 'Ваша оплата за бронирование ',
        from: ' c ',
        to: ' на ',
        on: ' по ',
        soonWillEmail: 'Скоро мы пришлем письмо на почту, которую вы указали при бронировании, где подробно расскажем о предстоящем курсе.',
        before: 'Перед началом занятий советуем почитать статьи в нашем онлайн-журнале:',
        firstTravel: 'Инструкция для первого яхтенного путешествия',
        advices: 'Советы и воспоминания об учебе шкиперов Силы ветра',
        aboutYachtLicence: 'Все, что нужно знать о яхтенных правах',
        ifHaveQuestions: 'Если у вас есть вопросы, позвоните нам по телефону +7 495 108 15 03 или напишите на почту ',
        thanksForBook: 'Спасибо за бронирование! Ваш платеж {{places}} {{accusativePlaces}} на {{orderName}} ',
        thanksForBookWithInstallment: 'Мы отправили заявку на рассмотрение в банк. Как только он примет решение о рассрочке, вы получите письмо на почту, которую указывали при бронировании.',
        practiceFrom: ' c ',
        inProcess: ' находится в обработке.',
        successPayment: 'Поздравляем! Вы успешно оплатили {{places}} {{dativePlaces}} на {{orderName}} c',
        successPaymentWithInstallment: 'Поздравляем, бронирование подтверждено, а рассрочка уже одобрена банком. Совсем скоро вы отправитесь в настоящее приключение. Мы сами в предвкушении!',
        howGetLicense: 'Как получить права и стать капитаном',
        youngYachtMen: 'Молодые яхтсмены о том, как стать капитаном',
        online: ' онлайн ',
        offline: ' офлайн ',
        schoolTo: ' по ',
        successTheory: 'Поздравляем! Вы успешно оплатили курс теории',
        beingProcessing: 'находится в обработке.',
        successBookLecture: 'Поздравляем! Вы успешно записались на лекцию',
        soonWillEmailLecture: 'Мы отправим электронное письмо со всеми подробностями предстоящей лекции на адрес, который вы указали при бронировании.',
        successPayLecture: 'Поздравляем! Вы успешно оплатили участие в лекции',
        joinTelegram: 'Обязательно вступите в группу в телеграме и зайдите на обучающую платформу',
        yourTG: 'Канал вашей группы в ТГ',
        learningPlatform: 'Обучающая платформа',
        code: 'Код для входа',
    },
    preparationSteps: {
        mainTitle: 'Как подготовиться',
        checkInsurance: 'Проверить страховку',
        firstBlockText: 'Мы добавили полисы Росгосстраха во все тренировки, прогулки и гонки. Вам осталось только подтвердить согласие.\n Пара секунд — и вы под защитой. Доплачивать за страховку не нужно, это бесплатно.',
        firstBlockInsurance: 'Страховка не для галочки — с полисом нашего партнера',
        addEventToCalendar: 'Добавить событие в календарь',
        insuranceCompany: 'Росгосстрах',
        seeUseful: 'Посмотреть, что есть полезного в нашем журнале',
        expectationInsurance: 'Оформление страховки',
        designInsurance: 'Страховка оформляется, пожалуйста, подождите',
        insuranceIssued: 'Страховка оформлена',
        dataCanBeEdited: 'Личные данные можно редактировать до даты события',
        buttonEdit: 'Редактировать',
        buttonToCheckout: 'Перейти к оформлению',
        buttonReadMore: 'Подробнее',
    },
    feedback: {
        poorly: 'Плохо',
        unsatisfactory: 'Неудовлетворительно',
        satisfactorily: 'Удовлетворительно',
        good: 'Хорошо',
        perfectly: 'Отлично',
        ratePlease: 'Оцените работу нашей системы бронирования',
        commentPlaceholder: 'Будем рады услышать пожелания, которые помогут нам сделать систему бронирования лучше',
        thanks: 'Спасибо за отзыв!',
        send: 'Отправить',
    },
    profile: {
        certificatesSubscriptions: {
            blockTitle: 'Сертификаты и абонементы',
            giveExperience: 'Подарить впечатления',
            certificateLabel: 'Проверить сертификат',
            certificatePlaceholder: 'Введите сертификат',
            certificateNotFound: 'Сертификат не существует',
            certificateNotAvailable: 'Сертификат не активен',
            certificateBalance: 'Баланс сертификата',
            certificateApplies: 'Распространяется на',
            certificateCountry: 'Страна применения',
            certificateAvailableTo: 'Действителен до',
            check: 'Проверить',
            subscription: 'Абонемент',
            subscriptionBalance: 'Баланс абонемента',
            subscriptionDiscount: 'Скидка на килевые яхты и групповые лучи',
            subscriptionIndividualDiscount: 'Скидка на индивидуальные лучи',
            subscriptionDiscountRace: 'Скидка на гонки',
            subscriptionDiscountCup: 'Скидка на кубки',
            subscriptionEmpty: 'У вас нет активного абонемента',
            noAvailableSubscriptions: 'Нет доступных абонементов',
            buy: 'Купить',
            more: 'Подробнее',
            moreCertificateLink: 'https://silavetra.com/certificate'
        },
        events: {
            blockTitle: 'Мои события',
            noPurchases: "Покупок еще нет",
            chooseSomething: "Выбрать что-нибудь",
            chooseSomethingLink: 'https://silavetra.com/travel',
            upcomingEvents: "Предстоящие события",
            pastEvents: "Прошедшие события",
            loadMore: "Загрузить еще",
            certificateApplied: "Применен сертификат",
            promocodeApplied: "Применен промокод",
            place: "мест",
            remainingPayment: "ещё {{amount}} ₽ к оплате",
        },
        notifications: {
            blockTitle: 'Уведомления',
            newsletterConsent: 'Соглашаюсь на рассылку новостей и предложений',
        },
        accountActions: {
            leave: "Сменить аккаунт"
        },
        certificates: {
            blockTitle: 'Сертификаты',
        },
        data: {
            phoneTaken: 'Этот номер уже занят.',
            blockTitle: 'Персональные данные',
            nicknameLable: 'Как к вам обращаться',
            nicknamePlaceholder: 'Иванов Иван',
            nameLabel: 'Имя',
            namePlaceholder: 'Иван',
            surnameLabel: 'Фамилия',
            surnamePlaceholder: 'Иванов',
            phoneLabel: 'Номер телефона',
            emailLabel: 'Электронная почта',
            experienceLabel: 'Яхтенный опыт',
            experienceDefaultLabel: 'Укажите ваш опыт',
            experience0: 'нет опыта',
            experience1: 'пару раз был(а) на тренировке',
            experience2: 'хожу по колдунчикам и делаю оверштаг',
            experience3: 'умею ходить против и по ветру',
            experience4: 'сам(а) вооружаю лодку и вяжу узлы',
            experience5: 'сам(а) швартуюсь',
            experience6: 'прохожу все участки дистанции',
            experience7: 'участвую в гонках в роли рулевого',
            success: 'Данные успешно обновлены',
            save: 'Сохранить',
            passportInternational: 'Заграничный паспорт',
            passportRu: 'Паспорт РФ',
            travel: 'путешествий',
            for: 'для',
            enNameLabel: 'Имя (На латинице, как в паспорте)',
            enSurnameLabel: 'Фамилия (На латинице, Как в паспорте)',
            ruNameLabel: 'Имя (как в паспорте)',
            ruSurnameLabel: 'Фамилия (Как в паспорте)',
            birthdateLabel: '01.01.1990',
            passport: 'Серия и номер',
            passportPlaceholder: 'xx xx xxxx',
            dateEnPassport: 'Действителен до',
            datePassport: 'Выдан',
            datePassportPlaceholder: 'xx.xx.xxxx',
            passportFiles: 'Скан паспорта',
            passportFilesSubtitle: 'Страница с фото в формате jpg, png, heic или pdf',
            passportFilesBtn: 'Загрузить',
            citizenship: 'Гражданство',
            citizenshipPlaceholder: 'Россия',
            unsubscribed_news: 'Отписаться от новостей',
            telegram: {
                title: 'telegram',
                pattern: 'Вводите аккаунт телеграм через @, минимальное количество символов - 4',
                placeholder: '@silavetrasila',
            },
            error: {
                required: "Поле обязательно для заполнения",
                emailPattern: "Введите существующий адрес email",
                namePattern: "Имя не может содержать специальные символы",
                surnamePattern: "Фамилия не может содержать специальные символы",
                passPattern: "Номер паспорта написан с ошибкой",
                enPassPattern: "Максимальное кол-во символов – 25",
                passPatternLength: "Максимальное количество символов - 25",
                citizenshipPattern: "Гражданство не может содержать специальные символы",
                datePassPattern: "Введите дату в формате ДД.ММ.ГГГГ",
            }
        },
        exit: 'Exit',
        twofa: {
            modal: 'Подтвердите действие',
            placeholder: 'Код из сообщения на почте',
            submit: 'Подтвердить',
            resendAgain: 'Отправить заново через',
            resendSubmit: 'Отправить новый код',
        },
        navigationMenu: {
            title: "Личный кабинет",
            routes: {
                events: "События",
                certificates: "Сертификаты",
                seasonTicket: "Абонементы",
                notifications: "Уведомления",
                supportService: "Написать в службу заботы",
                accountActions: "Действия с аккаунтом"
            },
            mobileHeader: "Назад",
            footer: {
                title: "Нужна помощь?",
                subtitle: {
                    link: "в Телеграм",
                    phone: "+7 495 108-15-03",
                    firstSubtitle: "Пишите нам в чат на сайте или ",
                    secondSubtitle: ", звоните по номеру "
                }
            }
        }
    },
    logout: 'Выход из учетной записи',
    notFound: {
        pageNotFound: 'Страница не найдена',
        backToMain: 'Вернуться на главную'
    },
    newPassword: {
        saveAndContinue: 'Сохранить и продолжить',
        description: 'Мы сбросили ваш старый пароль. Придумайте новый',
        label: 'Новый пароль',
        placeholder: 'С цифрами, а лучше и с символами',
        error: {
            invalidToken: "Ссылка устарела. Для восстановления пароля запросите новое письмо",
            unknownError: "Произошла неизвестная ошибка. Попробуйте еще раз."
        }
    },
    tablet: {
        walk: 'Прогулки',
        sport: 'Спорт'
    },
    api: {
        usePhoneLogin: {
            unknownError: 'Что-то пошло не так',
            phoneLimit: 'Превышен лимит отправки СМС на номер телефона',
        },
        useApi: {
            notFound: 'Не найдено',
            instructorBusy: 'У выбранного инструктора уменьшилось количество доступных мест, пожалуйста, выберите другого',
        },
        errors: {
            backendError: "Система бронирования временно не работает, но мы уже знаем об этом и занимаемся восстановлением работоспособности."
        }
    },
    constructor: {
        redirectText: 'После авторизации мы перенаправим вас на корпоративную страницу'
    },
    agreements: {
      personalData: 'https://silavetra.com/personal-data'
    },
    certificate: {
      headerLabel: 'Бронирование',
      label: 'Подарочный сертификат',
      ownerName: 'Имя и Фамилия',
      country: 'Страна',
      extra: 'Сертификат действует в течение одного года и распространяется на все продукты Силы ветра. Обмену и возврату не подлежит.',
      price: 'Цена',
      wish: 'Пожелание',
      code: 'Код сертификата',
      productType: 'Тип продукта',
      form: {
        inputName: 'Укажите имя',
        inputNamePlaceholder: 'Имя',
        inputSurname: 'Укажите фамилию',
        inputSurnamePlaceholder: 'Фамилия',
        sender: 'отправителя',
        recipients: 'получателя',
        inputWish: 'Укажите пожелание',
        inputWishPlaceholder: 'Напишите пожелание для получателя...',
        inputWishMaxLength: 'Макс. количество символов: 45',
        inputEmail: 'Укажите почту',
        inputCurrency: 'Валюта',
        inputProductType: 'Тип продукта',
        inputCountry: 'Страна',
        inputNominal: 'Укажите номинал сертификата',
        inputSum: 'Итоговая сумма',
        inputSendToEmail: 'Отправить получателю по электронной почте',
        submit: 'Купить',
        description: 'До оформления подарочного сертификата осталась всего пара шагов. После оплаты вам будет доступен сам сертификат в электронном виде и уникальный код, по которому можно забронировать путешествие, место в Школе капитанов или на парусную тренировку.',
        inputPhone: 'Укажите номер телефона',
        inputSendersEmail: 'Укажите почту отправителя',
        success: {
          title: 'Ура, поздравляем! Отправили подарочный сертификат вам на почту — порадуйте своих друзей и близких!',
          certNumber: 'Номер вашего сертификата',
          downloadButton: 'Скачать сертификат',
          onTheMain: 'На главную страницу',
          orderOneMore: 'Оформить еще один',
        }
      },
    },
    subscriptions: {
      headerTitle: 'Абонемент',
      countryOfUsage: 'Страна применения',
      ownerEmail: 'Почта держателя',
      payWithCert: 'Оплатить сертификатом',
      enterCert: 'Введите сертификат',
      balance: 'Баланс',
      debit: 'Списание',
      publicOffer: 'https://silavetra.com/legal/sailing-pass',
      termsPurchase: 'Ознакомился с изменениями условий покупки абонементов',
      termsPurchaseError: 'Пожалуйста, подтвердите согласие с условиями покупки абонементов',
      termsPurchaseLink: 'https://silavetra.com/abonement',
      title: 'До оформления абонемента осталась всего пара шагов. После оплаты вы сможете использовать абонемент для оплаты тренировок на наших базах.',
      nominal: 'Номинал абонемента -',
      discountGroupLabel: 'Скидка на групповые лучи',
      discountKilLabel: 'Килевые яхты',
      discountRaceLabel: 'Гонки',
      discountIndividualLabel: 'На индивидуальные лучи',
      name: 'Имя',
      andSurname: 'и фамилия',
      price: 'К оплате',
      amountOfAbonement: 'Выберите стоимость',
      isHelpNeeded: 'Нужна помощь?',
      subscriptionRemainder: 'Остаток на абонементе',
      writeToUs: 'Пишите нам в чат на сайте или ',
      callByNumber: ' звоните по номеру ',
      telegram: 'в Телеграм',
      telegramLink: 'https://t.me/silavetrahelp',
      phone: '+7 495 108-15-03',
      phoneFormatted: '+74951081503',
      usePromo: 'Применить промокод',
      certificateDiscount: 'скидка с сертификата',
      success: {
        title: 'Ура, поздравляем! Абонемент оформлен и готов к использованию — удачных занятий!',
        howToUse: 'Как использовать абонемент:',
        step1: '1. Войдите в свой аккаунт (с которого покупали абонемент).',
        step2: '2. Выберите желаемую тренировку.',
        step3: '3. На экране оплаты поставьте галочку «Оплатить абонементом».',
        step4: '4. С вашего абонемента спишется сумма за тренировку с учетом вашей скидки.',
        step5: '5. Вы можете просмотреть баланс вашего абонемента в личном кабинете или связаться с членом нашей команды.',
        redirect: 'Вы будете перенаправлены на оформление продукта через:',
        redirectSeconds: 'секунд',
        onMain: 'На главную страницу',
        toBooking: 'К бронированию'
      }
    },
    generic: {
      dropzone: {
        dropFile: 'Перенесите файл (или нажмите)',
        uploadFile: "Загрузите файл",
        formatTooLarge: 'Формат слишком большой',
        formatNotAccepted: 'Формат не поддерживается',
        invalidType: 'Неподдерживаемый тип файла',
        delete: 'Удалить'
      }
    },
    paymentPay: {
      methods: {
        card: 'Оплатить банковской картой',
        sub: 'Оплатить абонементом',
        cert: 'Оплатить сертификатом',
        cash: 'Оплатить наличными',
      },
      remainder: {
        sub: 'Остаток после бронирования',
        subAfterPayment: 'Остаток после покупки',
        subToPayment: 'Осталось оплатить',
        cert: 'Остаток к оплате',
      },
      selectMethod: 'Выбор способа оплаты',
      noneActiveSub: 'У вас нет активных абонементов',
      notEnoughBonus: 'недостаточно баллов',
      bonusCount: 'баллов',
      notEnoughMoney: 'недостаточно средств',
      promoDiscount: 'Скидка по промокоду',
      certBalance: 'Баланс сертификата',
      payExtra: 'Доплатить',
      payByCard: 'картой',
      payByCash: 'наличными',
      wrongPromo: 'Неправильный номер промокода',
      subscription: 'Абонемент',
    },
    orders: {
      statistic: {
        slots: 'Тренировки',
        arrivals: 'Приключения и Практики',
        groups: 'Теория и Лекторий',
        count: 'Кол-во покупок'
      }
    }
}